import axios from "axios";
import {
    masterScenarioUpload,
    SET_UPLOAD_SUCCESS_STATUS,
    // SET_EXTRACTION_REQUEST,
    // SET_EXTRACTION_SUCCESS,
    // SET_EXTRACTION_ERROR,
    // SET_BULK_UPLOAD_REQUEST,
    // SET_BULK_UPLOAD_SUCCESS,
    // SET_BULK_UPLOAD_ERROR
} from "../../constants/closeLoop/scenarioVariationUpload/uploadVariationUploadConstants";

export const uploadInuputFilesForVariationCreation = (
    masterScenarioFiles,
    sddFile,
    fileSystem,
    simulator,
    model
) => ({
    type: masterScenarioUpload().SET_MASTER_INPUT_FILE_UPLOAD,
    payload: masterScenarioFiles,
    sddFile,
    fileSystem,
    simulator,
    model,
});

export const setUploadMasterInputProgress = (id, progress) => ({
    type: masterScenarioUpload().SET_MASTER_INPUT_FILE_PROGRESS,
    payload: {
        id,
        progress,
    },
});

export const successUploadMasterInputFile = (id) => ({
    type: masterScenarioUpload().SUCCESS_UPLOAD_MASTER_INPUT_FILE,
    payload: id,
});

export const failureUploadMasterInputFile = (id) => ({
    type: masterScenarioUpload().FAILURE_UPLOAD_MASTER_INPUT_FILE,
    payload: id,
});

export const resetMasterFileUpload = () => ({
    type: masterScenarioUpload().RESET_UPLOAD_MASTER_INPUT_FILE,
});

export const uploadMasterInputFile = (files) => (dispatch) => {
    let counter = 0;
    if (files.length) {
        files.forEach(async (file) => {
            const formPayload = new FormData();
            formPayload.append("files", file.file);
            formPayload.append("SDD", file.sddFile);
            formPayload.append("fileSystem", file.fileSystem);
            formPayload.append("simulator", file.simulator);
            formPayload.append("model", file.model);
            console.log("files", file.file);
            console.log("SDD", file.sddFile);
            console.log("MasterFileSystem", file.fileSystem);
            console.log("simulator", file.simulator);
            console.log("model", file.model);
            try {
                await axios({
                    url: "/close_loop/master_scenario_input/upload",
                    method: "post",
                    data: formPayload,
                    onUploadProgress: (progress) => {
                        const { loaded, total } = progress;
                        const percentageProgress = Math.floor((loaded / total) * 100);
                        dispatch(setUploadMasterInputProgress(file.id, percentageProgress));
                    },
                });
                dispatch(successUploadMasterInputFile(file.id));
                counter = counter + 1;
                if (counter === files.length) {
                    dispatch({ type: SET_UPLOAD_SUCCESS_STATUS, uploadStatus: true });
                }
            } catch (error) {
                dispatch(failureUploadMasterInputFile(file.id));
            }
        });
    }
};

export const resetUploadStatus = () => ({
    type: SET_UPLOAD_SUCCESS_STATUS, uploadStatus: false
});

// export const extractImagesAndDescription = (simulator, model) => (dispatch) => {
//     try {
//         dispatch({
//             type: SET_EXTRACTION_REQUEST,
//         });
//         axios({
//             url: `/close_loop/bulk_scenario_image_and_description/extraction`,
//             method: "POST",
//             data: { simulatorName: simulator, modelName: model },
//         })
//             .then((response) => {
//                 if (response && response.status === 200) {
//                     dispatch({
//                         type: SET_EXTRACTION_SUCCESS,
//                         status: response.data,
//                     });
//                 } else {
//                     dispatch({
//                         type: SET_EXTRACTION_ERROR,
//                         payload: "Error occured while fetching the extraction status",
//                     });
//                 }
//             })
//             .catch((error) => {
//                 if (
//                     Object.prototype.hasOwnProperty.call(error, "response") &&
//                     Object.prototype.hasOwnProperty.call(error.response, "data") &&
//                     Object.prototype.hasOwnProperty.call(error.response.data, "message")
//                 ) {
//                     dispatch({
//                         type: SET_EXTRACTION_ERROR,
//                         payload: error.response.data.message,
//                     });
//                 } else {
//                     dispatch({
//                         type: SET_EXTRACTION_ERROR,
//                         payload: "Something Went Wrong, Please Try Again!!",
//                     });
//                 }
//             });
//     } catch (error) {
//         console.log("error msg", error);
//         const errorMsg = error.message || "Error occurred while fetching this request!";
//         dispatch({ type: SET_EXTRACTION_ERROR, payload: errorMsg });
//     }
// };

// export const uploadBulkScenarioFiles = (simulator, model) => (dispatch) => {
//     try {
//         dispatch({
//             type: SET_BULK_UPLOAD_REQUEST,
//         });
//         axios({
//             url: `/close_loop/bulk_scenario_file/upload`,
//             method: "POST",
//             data: { simulatorName: simulator, modelName: model },
//         }).then((response) => {
//             if (response && response.status === 200) {
//                 console.log("bulk upload status", response);
//                 dispatch({
//                     type: SET_BULK_UPLOAD_SUCCESS,
//                     data: response.data
//                 })
//             }
//         })
//         .catch((error) => {
//             if (
//                 Object.prototype.hasOwnProperty.call(error, "response") &&
//                 Object.prototype.hasOwnProperty.call(error.response, "data") &&
//                 Object.prototype.hasOwnProperty.call(error.response.data, "message")
//             ) {
//                 dispatch({
//                     type: SET_BULK_UPLOAD_ERROR,
//                     payload: error.response.data.message,
//                 });
//             } else {
//                 dispatch({
//                     type: SET_BULK_UPLOAD_ERROR,
//                     payload: "Something Went Wrong, Please Try Again!!",
//                 });
//             }
//         });;
//     } catch (error) {
//         console.log("error msg", error);
//         const errorMsg = error.message || "Error occurred while fetching this request!";
//         dispatch({ type: SET_BULK_UPLOAD_ERROR, payload: errorMsg });
//     }
// };
